import React, { ReactElement } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { NavLink, useNavigate } from "react-router-dom";

import { Button, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Grid from "@mui/material/Unstable_Grid2";
import useMediaQuery from "@mui/material/useMediaQuery";

import AppFooter from "components/footer/AppFooter";
import Login from "components/login/Login";
import IconSelector from "components/shared/images/IconSelector";

const LoginPage = (): ReactElement => {
 const intl = useIntl();
 const navigate = useNavigate();

 const theme = useTheme();
 const desktopViewPort = useMediaQuery(theme.breakpoints.up("md"));

 const handleGoToRegistration = () => {
  navigate("/registration");
 };
 return (
  <Grid container height="100vh">
   <Grid xs={desktopViewPort ? 2 : 0}></Grid>
   <Grid xs={desktopViewPort ? 8 : 12} height="100%" padding={2}>
    <Stack justifyContent={"space-between"} height={"100%"} width="stretch" alignContent="center">
     <Stack sx={{ p: 2, height: "fill-available", justifyContent: "center" }} alignItems="center">
      <Stack minWidth={desktopViewPort ? 400 : 300} maxWidth={400}>
       <Stack spacing={4}>
        <Stack direction="row" justifyContent="space-between" alignItems="flex-end">
         <img
          alt="KonsoleX Logo"
          src={`${process.env.PUBLIC_URL}/svg/loghi/KX_hor_B.svg`}
          style={{ maxWidth: "60%" }}
         />
         <Button
          onClick={handleGoToRegistration}
          variant="kxActionButton"
          endIcon={<IconSelector icon="ArrowForwardIcon" />}>
          <FormattedMessage id="login.signUp" />
         </Button>
        </Stack>
        <Typography variant="h5" textAlign="left">
         {intl.formatMessage({ id: "app.login" })}
        </Typography>
       </Stack>
       <Login />
       <Stack mt={2}>
        <NavLink to="/reset-password" style={{ color: "#00278B" }}>
         {intl.formatMessage({ id: "login.forgottenPassword" })}
        </NavLink>
       </Stack>
      </Stack>
     </Stack>
     <Stack spacing={2} width={"100%"}>
      <Grid container spacing={2} sx={{ mt: 2 }}>
       <Grid xs={desktopViewPort ? 4 : 12}>
        <Stack>
         <Typography variant="subtitle2">
          <FormattedMessage id="app.payments" />
         </Typography>
         <Stack direction="row" alignItems="center" justifyContent="center" spacing={2}>
          <Stack alignItems="center" justifyContent="center">
           <IconSelector icon="CreditCardIcon" props={{ color: "kxOrange" }} />
           <Typography variant="extraSmall">Card</Typography>
          </Stack>
          <Stack alignItems="center" justifyContent="center">
           <IconSelector icon="AccountBalanceIcon" props={{ color: "kxOrange" }} />
           <Typography variant="extraSmall">Bank</Typography>
          </Stack>
          <Stack alignItems="center" justifyContent="center">
           <IconSelector icon="StripeIcon" />
           <Typography variant="extraSmall">Stripe</Typography>
          </Stack>
          <Stack alignItems="center" justifyContent="center">
           <IconSelector icon="KlarnaIcon" />
           <Typography variant="extraSmall">Klarna</Typography>
          </Stack>
         </Stack>
        </Stack>
       </Grid>
       <Grid xs={desktopViewPort ? 4 : 12}>
        <Stack>
         <Stack>
          <Typography variant="subtitle2">
           <FormattedMessage id="app.providers" />
          </Typography>
          <Stack direction="row" justifyContent="center" alignItems="center" spacing={2}>
           <Stack alignItems="center" justifyContent="center">
            <img
             src={`${process.env.PUBLIC_URL}/svg/loghi/logo.jpg`}
             alt="provider-logo"
             height={25}
             width={25}
            />
            <Typography variant="extraSmall">KonsoleX</Typography>
           </Stack>
           <Stack alignItems="center" justifyContent="center">
            <img
             src={`${process.env.PUBLIC_URL}/svg/providers/contabo.svg`}
             alt="provider-logo"
             height={25}
             width={25}
            />
            <Typography variant="extraSmall">Contabo</Typography>
           </Stack>
          </Stack>
         </Stack>
        </Stack>
       </Grid>
       <Grid xs={desktopViewPort ? 4 : 12}>
        <Stack>
         <Stack>
          <Typography variant="subtitle2">
           <FormattedMessage id="app.registrar" />
          </Typography>
          <Stack direction="row" justifyContent="center" alignItems="center" spacing={2}>
           <Stack alignItems="center" justifyContent="center">
            <img
             width={25}
             height={25}
             src={`${process.env.PUBLIC_URL}/svg/providers/ibs.svg`}
             alt="provider"
            />
            <Typography variant="extraSmall">IBS</Typography>
           </Stack>
           <Stack alignItems="center" justifyContent="center">
            <img
             width={30}
             height={25}
             src={`${process.env.PUBLIC_URL}/svg/providers/ascio.svg`}
             alt="provider"
            />
            <Typography variant="extraSmall">Ascio</Typography>
           </Stack>
          </Stack>
         </Stack>
        </Stack>
       </Grid>
      </Grid>
      <AppFooter />
     </Stack>
    </Stack>
   </Grid>
   <Grid xs={desktopViewPort ? 2 : 0}></Grid>
  </Grid>
 );
};

export default LoginPage;
